import { EditFormTypes } from "src/common-types";

export const PESTS_EDIT_LIST_ITEMS: EditFormTypes[] = [
  {
    id: "name",
    label: "Название вредителя: ",
    inputs: [{ type: "string", placeholder: "Название" }],
  },
];
